import clsx from 'clsx'
import type { ReactNode } from 'react'
import { View } from 'react-native'
import type { ViewProps } from 'react-native-svg/lib/typescript/fabric/utils'

export const QuoteSection = ({ className, ...otherProps }: ViewProps): ReactNode => (
  <View
    className={clsx('border-l-medium border-l-2 border-secondary-text-contrast-low pl-5', className)}
    {...otherProps}
  />
)
